import { 
    createBrowserRouter, 
    createRoutesFromElements,
    Route
} from 'react-router-dom';
import App from './App';
import StudentLogin from './screens/students/StudentLogin';
import StudentRegister from './screens/students/StudentRegister';
import StudentNewAnswer from './screens/students/StudentNewAnswer';
import StudentNewAnswer2 from './screens/students/StudentNewAnswer2';
import StudentProfile from './screens/students/StudentProfile';
import StudentSubjects from './screens/students/StudentSubjects';
import StudentSubscriptions from './screens/students/StudentSubscriptions';
import StudentsManage from './screens/students/StudentsManage';
import StudentPlans from './screens/students/StudentPlans';
import StudentsAskNew  from './screens/students/StudentsAskNew';
import StudentAskDetails from './screens/students/StudentAskDetails';
import StudentAskType from './screens/students/StudentAskType';
import StudentScreen from './screens/students/StudentScreen';
import StudentPreviousAnswers from './screens/students/StudentPreviousAnswers';
import StudentWatchNew from './screens/students/StudentWatchNew';
import StudentWatchQuestion from './screens/students/StudentWatchQuestion';
import StudentTeachers from './screens/students/StudentTeachers';
import StudenCamera from './screens/students/StudenCamera';
import StudentUpload from './screens/students/StudentUpload';
import StudentSubscribe from './screens/students/StudentSubscribe';
import StudentAfterPayment from './screens/students/StudentAfterPayment';
import StudentAfterUpgradePayment from './screens/students/StudentAfterUpgradePayment';
import StudentsUpgradeSubscription from './screens/students/StudentsUpgradeSubscription';
import StudentCancelSubscription from './screens/students/StudentCancelSubscription'
import StudentWatchCourse from './screens/students/StudentWatchCourse';

import TeacherLogin from './screens/teachers/TeacherLogin';
import TeacherNewQuestions2 from './screens/teachers/TeacherNewQuestions2';
import TeacherNewQuestions from './screens/teachers/TeacherNewQuestions';
import TeacherRegister from './screens/teachers/TeacherRegister';
import TeacherProfile from './screens/teachers/TeacherProfile';
import TeacherNewSubject from './screens/teachers/TeacherNewSubject';
import TeacherSubjects from './screens/teachers/TeacherSubject';
import TeacherPublicProfile from './screens/teachers/TeacherPublicProfile';
import TeacherPublicSubject from './screens/teachers/TeacherPublicSubject';
import TeacherEditSubject from './screens/teachers/TeacherEditSubject';
import TeacherPlanSubscribe from './screens/teachers/TeacherPlanSubscribe';
import TeacherWatchNew from './screens/teachers/TeacherWatchNew';
import TeacherAnswerDetails from './screens/teachers/TeacherAnswerDetails';
import TeacherAnswerType from './screens/teachers/TeacherAnswerType';
import TeacherScreen from './screens/teachers/TeacherScreen';
import TeacherPreviousAnswers from './screens/teachers/TeacherPreviousAnswers';
import TeacherWatchQuestion from './screens/teachers/TeacherWatchQuestion';
import TeacherWatchQuestion2 from './screens/teachers/TeacherWatchQuestion2';
import TeacherWatchAnswer from './screens/teachers/TeacherWatchAnswer';
import TeacherAllStudents from './screens/teachers/TeacherAllStudents';
import TeacherCamera from './screens/teachers/TeacherCamera';
import TeacherOnboarding from './screens/teachers/TeacherOnboarding';
import TeacherUpload from './screens/teachers/TeacherUpload';
import TeacherSetupPayment from './screens/teachers/TeacherSetupPayment';
import TeacherPaymentCallback from './screens/teachers/TeacherPaymentCallback';
import TeacherRevenue from './screens/teachers/TeacherRevenue';
import TeacherNewCourse from './screens/teachers/TeacherNewCourse';
import TeacherNewLessons from './screens/teachers/TeacherNewLessons';
import TeacherWatchCourse from './screens/teachers/TeacherWatchCourse';
import TeacherReuseAnswer from './screens/teachers/TeacherReuseAnswer';
import TeacherWatchAnswer2 from './screens/teachers/TeacherWatchAnswer2';
import TeacherAiAnswer from './screens/teachers/TeacherAiAnswer';
        

const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<App />} >
        {/* STUDENT ROUTES */}
        <Route index={true} path='/' element={<TeacherLogin />} />

        <Route path="/studentregister" element={<StudentRegister />} />
        <Route path="/studentlogin" element={<StudentLogin />} />
        <Route path='/studentnewanswer' element={<StudentNewAnswer2 />} />
        <Route path='/studentnewanswer/page/:pageNumber' element={<StudentNewAnswer2 />} />
        <Route path="/studentasknew" element={<StudentsAskNew />} />
        <Route path='/studentasknew/page/:pageNumber' element={<StudentsAskNew />} />
        <Route path="/studentsubjects" element={<StudentSubjects />} />
        <Route path="/studentsubjects/page/:pageNumber" element={<StudentSubjects />} />
        <Route path="/studentteachers" element={<StudentTeachers />} />
        <Route path="/studentteachers/page/:pageNumber" element={<StudentTeachers />} />
        <Route path="/studentsubscriptions" element={<StudentSubscriptions />} />
        <Route path="/studentsubscriptions/page/:pageNumber" element={<StudentSubscriptions />} />
        <Route path="/studentprofile" element={<StudentProfile />} />
        <Route path="/studentplans/:id" element={<StudentPlans />} />
        <Route path="/studentsmanage/:id" element={<StudentsManage />} />
        <Route path="/studentaskdetails/:id" element={<StudentAskDetails />} />
        <Route path="/studentasktype/:id" element={<StudentAskType />} />
        <Route path="/studentscreen/:id" element={<StudentScreen />} />
        <Route path="/studentpreviousanswers/:id" element={<StudentPreviousAnswers />} />
        <Route path="/studentwatchnew/:id" element={<StudentWatchNew />} />
        <Route path="/studentwatchquestion/:id" element={<StudentWatchQuestion />} />
        <Route path="/studentcamera/:id" element={<StudenCamera />} />
        <Route path="/studentupload/:id" element={<StudentUpload />} />
        <Route path="/studentafterpayment/:id" element={<StudentAfterPayment />} />
        <Route path="/studentsubscribe/:id" element={<StudentSubscribe />} />
        <Route path="/studentsupgradesubscription/:id" element={<StudentsUpgradeSubscription />} />
        <Route path="/studentafterupgradepayment/:id" element={<StudentAfterUpgradePayment />} />
        <Route path="/studentcancelsubscription/:id" element={<StudentCancelSubscription />} />
        <Route path="/studentwatchcourse/:id" element={<StudentWatchCourse />} />
        

        {/* TEACHER ROUTES */}
        <Route path="/teacherlogin" element={<TeacherLogin />} />
        <Route path="/teachernewquestions" element={<TeacherNewQuestions2 />} />
        <Route path="/teachernewquestions/page/:pageNumber" element={<TeacherNewQuestions2 />} />
        <Route path="/teachersubjects" element={<TeacherSubjects />} />
        <Route path="/teachersubjects/page/:pageNumber" element={<TeacherSubjects />} />
        <Route path="/teacherpreviousanswers/:id" element={<TeacherPreviousAnswers />} />
        <Route path="/teacherpreviousanswers/:pageNumber/:id" element={<TeacherPreviousAnswers />} />
        <Route path="/teacherregister" element={<TeacherRegister />} />
        <Route path="/teacherprofile" element={<TeacherProfile />} />
        <Route path="/teachernewsubject" element={<TeacherNewSubject />} />
        <Route path="/teacherpublicprofile/:id" element={<TeacherPublicProfile />} />
        <Route path="/teacherpublicsubject/:id" element={<TeacherPublicSubject />} />
        <Route path="/teachereditsubject/:id" element={<TeacherEditSubject />} />
        <Route path="/teacherplansubscribe/:id" element={<TeacherPlanSubscribe />} />
        <Route path="/teacherwatchnew/:id" element={<TeacherWatchNew />} />
        <Route path="/teacheranswerdetails/:id" element={<TeacherAnswerDetails />} />
        <Route path="/teacheranswertype/:id" element={<TeacherAnswerType />} />
        <Route path="/teacherscreen/:id" element={<TeacherScreen />} />
        <Route path="/teacherwatchquestion/:id" element={<TeacherWatchQuestion />} />
        <Route path="/teacherwatchquestion2/:id" element={<TeacherWatchQuestion2 />} />
        <Route path="/teacherwatchanswer/:id" element={<TeacherWatchAnswer />} />
        <Route path="/teacherallstudents" element={<TeacherAllStudents />} />
        <Route path="/teachercamera/:id" element={<TeacherCamera  />} />
        <Route path="/teacheronboarding" element={<TeacherOnboarding  />} />
        <Route path="/teacherupload/:id" element={<TeacherUpload />} />
        <Route path="/teachersetuppayment" element={<TeacherSetupPayment />} />
        <Route path="/teacherpaymentcallback" element={<TeacherPaymentCallback />} />
        <Route path="/teacherrevenue" element={<TeacherRevenue />} />
        <Route path="/teachernewcourse/:id" element={<TeacherNewCourse />} />
        <Route path="/teachernewlessons/:id" element={<TeacherNewLessons />} />
        <Route path="/teacherwatchcourse/:id" element={<TeacherWatchCourse />} />
        <Route path="/teacherreuseanswer/:pageNumber/:id/:sid" element={<TeacherReuseAnswer />} />
        <Route path="/teacherreuseanswer/:id/:sid" element={<TeacherReuseAnswer />} />
        <Route path="/teacherwatchanswer2/:aid/:id" element={<TeacherWatchAnswer2 />} />
        <Route path="/teacheraianswer/:id" element={<TeacherAiAnswer />} />


      </Route>
    )
  );

  export default  router